import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { Popover } from "./Popover";
import { PopoverContent } from "./PopoverContent";

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        PopoverContent,
        Popover,
    ],
    exports: [
        PopoverContent,
        Popover,
    ],
    entryComponents: [
        PopoverContent
    ]
})
export class IgnitePopoverModule { }